var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-cart-data loggedin-cart"},[_c('div',{staticClass:"col-12 pt-3 product-list-table"},[_c('my-orders-index')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }